import React from 'react';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import IconButton from '@mui/material/IconButton';

interface Props {
    isPlaying: boolean;
    onPlayClick: () => void;
    onPauseClick: () => void;
}

const PlayPauseButton: React.FC<Props> = props => {
    const handlePlayPauseClick = () => {
        if (props.isPlaying) {
            props.onPauseClick();
        } else {
            props.onPlayClick();
        }
    };

    return (
        <IconButton size="large" onClick={handlePlayPauseClick}>
            {props.isPlaying ? (
                <PauseIcon fontSize="inherit" />
            ) : (
                <PlayArrowIcon fontSize="inherit" />
            )}
        </IconButton>
    );
};

export default PlayPauseButton;
